import { render, staticRenderFns } from "./RemoveCountdown.vue?vue&type=template&id=b8fbcc60&"
import script from "./RemoveCountdown.vue?vue&type=script&lang=js&"
export * from "./RemoveCountdown.vue?vue&type=script&lang=js&"
import style0 from "./RemoveCountdown.vue?vue&type=style&index=0&id=b8fbcc60&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports